export enum TRACKING_SOURCE {
  COMMENT = 'Comment',
  HOME_PAGE = 'Home Page',
  PRAYER_ON_COMMENT_MESSAGE = 'Prayer-On-Comment-Message',
  CONVERSATION = 'Conversation',
  PRAYER_SPACE = 'Hp Newsfeed',
  USER_FAVORITES_PAGE = 'User Favorites Page',
  INTENTION_PAGE = 'Intention-Page',
  INTENTION_CREATION_PAGE = 'Intention-Creation-Page',
  INTENTIONS_PAGE_PRAY = 'Intentions-Page-Pray',
  COMMUNITY_PAGE = 'Community-Page',
  SUGGESTED_SECTION = 'Suggested Section',
  SUGGESTED_PAGE = 'Suggested Page',
  CURRENTLY_SECTION = 'Currently Section',
  CURRENTLY_PAGE = 'Currently Page',
  TEAM_FAVORITES_SECTION = 'Team Favorites Section',
  TEAM_FAVORITES_PAGE = 'Team Favorites Page',
  TAG_SECTION = 'Tag Section',
  TAG_PAGE = 'Tag Page',
  COMMUNITIES_SEARCH = 'Communities Search',
  COMMUNITY_JOIN = 'Community-Join',
  INTENTION_POSTPUBCTA = 'Intention-PostPubCTA',
  PUBLICATION_PAGE = 'Publication Page',
  PUBLICATION_HEADER = 'Publication Header',
  INTENTIONS_THEMATIC_PAGE = 'Intentions-Thematic-Page',
  EMAIL_LINK = 'Email Link',
  SHARE_LINK = 'Share Link',
  PROFILE_PAGE = 'Profile Page',
  UNDEFINED = 'Undefined',
}

export enum PUBLICATION_TRACKING_SOURCE {
  FROM_EMAIL = 'email',
  FEED_READ_MORE = 'feed-read-more',
  COMMUNITY_READ_MORE = 'community-read-more',
  PUBLICATION_PAGE = 'publication-page',
  PROFILE = 'profile',
  USER_FAVORITES_PAGE = 'user-favorites-page',
}
